function socialMediaIntegrationUserDialog () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/social-media-integration-user/social-media-integration-user.html?$$REVISION$$'
  }
}

export { socialMediaIntegrationUserDialog }
